import { render, staticRenderFns } from "./_template-pillar-navigator.vue?vue&type=template&id=24150575&scoped=true&"
import script from "./_template-pillar-navigator.vue?vue&type=script&lang=js&"
export * from "./_template-pillar-navigator.vue?vue&type=script&lang=js&"
import style0 from "./_template-pillar-navigator.vue?vue&type=style&index=0&id=24150575&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24150575",
  null
  
)

export default component.exports